import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../services/store/userSlice";
import { setData } from '../../services/store/userSlice';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { pendings } from './data/pending-data';
import { trainingApi } from '../../services';
import AdminTrfListing from './admin-trf-listing';
import TrfDetailsView from './trf-details-view';
import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import { Card } from "primereact/card";

import { Dialog } from 'primereact/dialog';
// import MyTrainings from './my-trainings';
// import TrfList from './trf-list';
// import TeamTraining from './team-training';
import UpdateTRFAssesmentView from './update-trf-assesment-view';
import TrainingEffectivenessReport from './training-effectiveness-report';
import TrainingValidationForm from './training-validation-form';
import TrainingFeedbackForm from './training-feedback-form';
import EditEmpTrfForm from './update-emp-trf-from';

const TrainingDashboardComponents = () => {
    const [componentToRender, setComponentToRender] = useState(null)
    const user = useSelector(selectUser);
    const [trainingTaskList, setTrainingTaskList] = useState([]);
    const [showApproval, setShowApproval] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const storedUser = localStorage.getItem("user");
    const [empTrainingOverview, setEmpTrainingOverview] = useState([
        { label: 'Training Assigned', value: 0, severity: 'primary' },
        { label: 'Training Inprogress', value: 0, severity: 'primary' },
        { label: 'Training Attnded', value: 0, severity: 'primary' },
        { label: 'Training Completed', value: 0, severity: 'primary' },
        { label: 'Feedback Submitted', value: 0, severity: 'primary' },
        { label: 'Feedback Pending', value: 0, severity: 'danger' },
        { label: 'Assesment Submitted', value: 0, severity: 'primary' },
        { label: 'Assesment Pending', value: 0, severity: 'danger' },
    ]);

    // const [managerTrainingOverview, setManagerTrainingOverview] = useState([
    //     { label: 'Team Training Assigned', value: 0, severity: 'primary' },
    //     { label: 'Team Training Inprogress', value: 0, severity: 'primary' },
    //     { label: 'Team Training Attnded', value: 0, severity: 'primary' },
    //     { label: 'Team Training Completed', value: 0, severity: 'primary' },
    //     { label: 'Team Feedback Submitted', value: 0, severity: 'primary' },
    //     { label: 'Team Feedback Pending', value: 0, severity: 'danger' },
    //     { label: 'Team Assesment Submitted', value: 0, severity: 'primary' },
    //     { label: 'Team Assesment Pending', value: 0, severity: 'danger' },
    // ]);
    const [pendingActions, setPendingActions] = useState(pendings);
    const [clickedRowData, setClickedRowData] = useState({});

    const [detailsViewStatus, setdetailsViewStatus] = useState(false);
    const [clickedRecords, setClickedRecords] = useState({});
    const [updateAssesmentDialog, setUpdateAssesmentDialog] = useState(false);
    const [updateTMFeedbackDialog, setUpdateTMFeedbackDialog] = useState(false);
    const [validationDialog, setValidationDialog] = useState(false);
    const [feedbackDialog, setFeedbackDialog] = useState(false);

    const [trainingListCount, setTrainingListCount] = useState([]);
    const [editTrfDialog, setEditTrfDialog] = useState(false);

    useEffect(() => {
        // const roleId = user?.UserRoles?.[0]?.role_id;
        if (storedUser) {
            var data = JSON.parse(storedUser);
            getTrainingTaskList(data?.id);
            getTrainingTaskListCount();
        }
    }, []);

    const getTrainingTaskList = (userId) => {
        trainingApi.getTMTaskList(userId).then(resp => {
            setTrainingTaskList(resp.data.data);
        }).catch(e => {
        })
    }

    const getTrainingTaskListCount = () => {
        trainingApi.getAsignedTrainingListCount().then(resp => {
            let dataCount = resp?.data?.data;
            setEmpTrainingOverview([
                { label: 'Training Assigned', value: dataCount?.trainingAssigned, severity: 'primary' },
                { label: 'Training Inprogress', value: dataCount?.trainingInprogress, severity: 'primary' },
                { label: 'Training Attended', value: dataCount?.trainingAttended, severity: 'primary' },
                { label: 'Training Completed', value: dataCount?.trainingCompleted, severity: 'primary' },
                { label: 'Feedback Submitted', value: dataCount?.feedbackSubmitted, severity: 'primary' },
                { label: 'Feedback Pending', value: dataCount?.feedbackPending, severity: 'danger' },
                { label: 'Assesment Submitted', value: dataCount?.assesmentCompleted, severity: 'primary' },
                { label: 'Assesment Pending', value: dataCount?.assesmentPending, severity: 'danger' },
            ]);
            // setManagerTrainingOverview([
            //     { label: 'Team Training Assigned', value: dataCount?.teamTrainingAssigned, severity: 'primary' },
            //     { label: 'Team Training Inprogress', value: dataCount?.teamTrainingInprogress, severity: 'primary' },
            //     { label: 'Team Training Attended', value: dataCount?.teamTrainingAttended, severity: 'primary' },
            //     { label: 'Team Training Completed', value: dataCount?.teamTrainingCompleted, severity: 'primary' },
            //     { label: 'Team Feedback Submitted', value: dataCount?.teamFeedbackSubmitted, severity: 'primary' },
            //     { label: 'Team Feedback Pending', value: dataCount?.teamFeedbackPending, severity: 'danger' },
            //     { label: 'Team Assesment Submitted', value: dataCount?.teamAssesmentCompleted, severity: 'primary' },
            //     { label: 'Team Assesment Pending', value: dataCount?.teamAssesmentPending, severity: 'danger' },
            // ]);
        }).catch(e => {
        })
    }

    const openMeeting = (r, o) => {
        const link = r.link;
        window.open(link, '_blank');
    }

    const openForm = (r, o) => {
        dispatch(setData(r));
        navigate('/ess-forms');
    }
    /* Reload After Close Dialog */
    const reloadTrfHistory = () => {
        setEditTrfDialog(false);
        setdetailsViewStatus(false);
        setUpdateAssesmentDialog(false);
        setUpdateTMFeedbackDialog(false);
        setValidationDialog(false);
        if (storedUser) {
            var data = JSON.parse(storedUser);
            getTrainingTaskList(data?.id);
        }
    }
    /* Reload After Close Dialog */

    const updateEmpAssesment = (currentData) => {
        confirmDialog({
            // target: e.currentTarget,
            message: `Are you sure you submitted yor assesment form? Click YES, If not, Click No to submit assesment form`,
            header: 'Action Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: "p-button-danger",
            acceptLabel: 'YES',
            rejectLabel: 'NO',
            reject: () => {
                navigate('/ess-forms', { state: currentData?.trainingRequisitionForm?.trainingDetails[0]?.assesment_link });
            },
            accept: () => {
                let params = {
                    "id": currentData?.trainingRequisitionForm?.trainingDetails[0]?.id,
                    "is_assesment_completed": true
                }
                try {
                    trainingApi.updateEmployeeTraining(params).then(
                        (resp) => {
                            toast.success(resp.data.message);
                            setTimeout(() => {
                                if (storedUser) {
                                    var data = JSON.parse(storedUser);
                                    getTrainingTaskList(data?.id);
                                }
                            }, 1000);
                        },
                        (err) => {
                            toast.error(err.response.data.error);
                        }
                    );
                } catch (error) {
                    toast.error("Unable to update");
                }
            }
        });
    }

    const updateEmpFeedback = (currentData) => {
        confirmDialog({
            // target: e.currentTarget,
            message: `Are you sure you submitted yor feedback form? Click YES, If not, Click No to submit feedback form`,
            header: 'Action Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: "p-button-danger",
            acceptLabel: 'YES',
            rejectLabel: 'NO',
            reject: () => {
                navigate('/ess-forms', { state: currentData?.trainingRequisitionForm?.trainingDetails[0]?.feedback_link });
            },
            accept: () => {
                let params = {
                    "id": currentData?.trainingRequisitionForm?.trainingDetails[0]?.id,
                    "is_feedback_completed": true
                }
                try {
                    trainingApi.updateEmployeeTraining(params).then(
                        (resp) => {
                            toast.success(resp.data.message);
                            setTimeout(() => {
                                if (storedUser) {
                                    var data = JSON.parse(storedUser);
                                    getTrainingTaskList(data?.id);
                                }
                            }, 1000);
                        },
                        (err) => {
                            toast.error(err.response.data.error);
                        }
                    );
                } catch (error) {
                    toast.error("Unable to update");
                }
            }
        });
    }

    const renderValidationDialog = () => {
        return (<>
            <Dialog className='custom_popup' header="View TRF Details" visible={detailsViewStatus} onHide={() => reloadTrfHistory()} style={{ width: '80vw' }}>
                <TrfDetailsView clickedRowData={clickedRowData} type="approval" reload={reloadTrfHistory} userRole={user?.UserRoles?.[0]?.role_id} />
            </Dialog>
        </>)
    }

    const renderManagerValidationDialog = () => {
        return (<>
            <Dialog header="Trainig Validation" visible={validationDialog} style={{ width: '60vw' }} onHide={() => setValidationDialog(false)}>
                <TrainingValidationForm validationData={clickedRecords} closeDialoge={() => setValidationDialog(false)} reload={refreshTeamTrainingData} type="dashboard" selectedFeedbackType={0} />
            </Dialog>
        </>)
    }

    const renderManagerFeedbackDialog = () => {
        return (<>
            <Dialog header="Training Effectiveness Feedback" visible={feedbackDialog} style={{ width: '700px' }} onHide={() => setFeedbackDialog(false)}>
                <TrainingFeedbackForm feedbackData={clickedRecords} closeDialoge={() => setFeedbackDialog(false)} reload={refreshTeamTrainingData} type="dashboard" selectedFeedbackType={0} />
            </Dialog>
        </>)
    }

    const renderTRFAssesmentDialog = () => {
        return (<>
            <Dialog header="Update TRF Assesment" visible={updateAssesmentDialog} onHide={() => setUpdateAssesmentDialog(false)} style={{ width: '60vw' }}>
                <UpdateTRFAssesmentView clickedRowData={clickedRecords} reloadTrfHistory={reloadTrfHistory} />
            </Dialog>
        </>)
    }
    const renderTRFTMFeedbackDialog = () => {
        return (<>
            <Dialog header="Training Effectiveness Report" visible={updateTMFeedbackDialog} onHide={() => setUpdateTMFeedbackDialog(false)} style={{ width: '45vw' }}>
                <TrainingEffectivenessReport clickedRowData={clickedRecords} reloadTrfHistory={reloadTrfHistory} />
            </Dialog>
        </>)
    }

    const openRequiredAction = (r) => {
        setClickedRowData(r?.trainingRequisitionForm);
        // setdetailsViewStatus(true);
        setEditTrfDialog(true);
    }

    const editTrfDetailsDialog = () => {
        return (<>
            <Dialog header="TRF Approvals" visible={editTrfDialog} className='full_dialog' onHide={() => { setEditTrfDialog(false); }}>
                <EditEmpTrfForm reload={reloadTrfHistory} userTrfDetail={clickedRowData} type={0} />
            </Dialog>
        </>)
    }


    const trainingStatusTemp_1 = (rowData) => {
        if (rowData?.trainingDetailStatus === 1) {
            return <span>In Progress</span>;
        } else if (
            rowData?.trainingDetailStatus === 2 &&
            !rowData?.is_assessment &&
            !rowData?.is_feedback
        ) {
            return <span>Attended</span>;
        } else if (
            rowData?.trainingDetailStatus === 2 &&
            rowData?.is_assessment &&
            rowData?.is_feedback &&
            !rowData?.is_assesment_completed &&
            !rowData?.is_feedback_completed
        ) {
            return <span>Assesment Pending</span>;
        } else if (
            rowData?.trainingDetailStatus === 2 &&
            rowData?.is_assessment &&
            rowData?.is_feedback &&
            rowData?.is_assesment_completed &&
            !rowData?.is_feedback_completed
        ) {
            return <span>Feedback Pending</span>;
        } else if (
            rowData?.trainingDetailStatus === 2 &&
            rowData?.is_assessment &&
            rowData?.is_feedback &&
            rowData?.is_assesment_completed &&
            rowData?.is_feedback_completed
        ) {
            return <span>Completed</span>;
        } else {
            return <span>TODO</span>;
        }
    };

    const trainingStatusTemp = (rowData) => {
        if (rowData?.trainingDetailStatus === 1) {
            return <span>In Progress</span>;
        }
        if (rowData?.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData?.trainingType === 'Instructor-Led' &&
                !rowData?.is_assessment && !rowData?.is_feedback
            ) ||

            // Case 2: Non-Instructor-Led with specific criteria
            (rowData?.trainingType === 'Self-Paced' &&
                !rowData?.is_assessment && !rowData?.is_feedback
            )
        )
        ) {
            return <span>Attended</span>;
        }
        if (rowData?.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            // (rowData?.trainingType === 'Instructor-Led' &&
            //     rowData?.is_assessment &&
            //     rowData?.is_feedback &&
            //     !rowData?.is_assesment_completed &&
            //     !rowData?.is_feedback_completed
            // )
            (rowData?.trainingType === 'Instructor-Led' &&
                rowData?.is_assessment &&
                rowData?.is_feedback &&
                !rowData?.is_assesment_completed
            )
        )
        ) {
            return <span>Assessment Pending</span>;
        }
        if (rowData?.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData?.trainingType === 'Instructor-Led' &&
                rowData?.is_assessment &&
                rowData?.is_feedback &&
                rowData?.is_assesment_completed &&
                !rowData?.is_feedback_completed
            ) ||
            // Case 2: Non-Instructor-Led with specific criteria
            (rowData?.trainingType === 'Self-Paced' &&
                !rowData?.is_assessment &&
                rowData?.is_feedback &&
                !rowData?.is_assesment_completed &&
                !rowData?.is_feedback_completed
            )
        )
        ) {
            return <span>Feedback Pending</span>;
        }
        if (rowData?.trainingDetailStatus === 2 && (
            // Case 1: Instructor-Led training with everything completed
            (rowData?.trainingType === 'Instructor-Led' &&
                rowData?.is_assessment &&
                rowData?.is_feedback &&
                rowData?.is_assesment_completed &&
                rowData?.is_feedback_completed
            ) ||
            // Case 2: Non-Instructor-Led with specific criteria
            (rowData?.trainingType === 'Self-Paced' &&
                !rowData?.is_assessment &&
                rowData?.is_feedback &&
                // !rowData?.is_assesment_completed &&
                rowData?.is_feedback_completed
            )
        )
        ) {
            return <span>Completed</span>;
        }
        // Fallback
        return <span>TODO</span>;
    };

    const actionBody = (r, o) => {
        // return (<>
        //     {r.taskType === 'meeting' && <><Button className='p-button p-button-sm ess-table-button' onClick={() => openMeeting(r, o)} severity='primary' icon='pi pi-video' label='Join' style={{ width: '80px' }} /></>}
        //     {r.taskType === 'form' && <><Button className='p-button p-button-sm ess-table-button' onClick={() => openForm(r, o)} severity='secondary' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} /></>}
        //     {r.taskType === 'request' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} /></>}
        //     {r.taskType === 'Approval' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} onClick={openApproval} /></>}
        // </>)

        return (<>
            {r?.taskType === 'meeting' && <><Button className='p-button p-button-sm ess-table-button' severity='primary' icon='pi pi-video' label='Join' style={{ width: '80px' }} /></>}
            {r?.taskType === 'form' && <><Button className='p-button p-button-sm ess-table-button' severity='secondary' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} /></>}
            {r?.taskType === 'request' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} /></>}
            {/* {r.taskType === 'Approval' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} /></>} */}

            {/* {r?.taskType === 'Training' ? trainingStatusTemp(r?.trainingRequisitionForm?.trainingDetails[0]) : null} */}
            {r?.taskType === 'Training' ? trainingStatusTemp(r?.trainingId ? r?.trainingDetails : r?.trainingRequisitionForm?.trainingDetails[0]) : null}

            {r?.taskType === 'Approval' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} onClick={() => { openRequiredAction(r); }} /></>}

            {/* {r?.taskType === 'Provide Assessment & Feedback Links' && <>
            <Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} onClick={() => { updateTrfAssesment(r); }} />
            </>} */}

            {r?.taskType === 'Assessment Assignment' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} disabled={r?.trainingRequisitionForm?.trainingDetails[0]?.trainingDetailStatus === 2 && r?.trainingRequisitionForm?.trainingDetails[0]?.is_assessment && r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback && !r?.trainingRequisitionForm?.trainingDetails[0]?.is_assesment_completed && !r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback_completed ? false : true} onClick={() => { updateEmpAssesment(r); }} /></>}
            {r?.taskType === 'Feedback Assignment' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} disabled={r?.trainingRequisitionForm?.trainingDetails[0]?.trainingDetailStatus === 2 && (r?.trainingRequisitionForm?.trainingDetails[0]?.trainingType === 'Instructor-Led' && r?.trainingRequisitionForm?.trainingDetails[0]?.is_assessment && r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback && r?.trainingRequisitionForm?.trainingDetails[0]?.is_assesment_completed && !r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback_completed) || (r?.trainingRequisitionForm?.trainingDetails[0]?.trainingType === 'Self-Paced' && !r?.trainingRequisitionForm?.trainingDetails[0]?.is_assessment && r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback && !r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback_completed) ? false : true} onClick={() => { updateEmpFeedback(r); }} /></>}

            {/* {r?.taskType === 'Manager Review' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} onClick={() => { openManagerValidateDialog(r); }} /></>} */}

            {/* {r?.taskType === 'Manager Review' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} onClick={() => { (r?.trainingType === 'Instructor-Led' && !r?.isManagerValidate && r?.is_assesment_completed && r?.is_feedback_completed) || (r?.trainingType === 'Self-Paced' && !r?.isManagerValidate && !r?.is_assesment_completed && r?.is_feedback_completed) ? openManagerValidateDialog(r) ? (r?.trainingType === 'Instructor-Led' && r?.isManagerValidate && r?.is_assesment_completed && r?.is_feedback_completed && !r?.isManagerFeedback) || (r?.trainingType === 'Self-Paced' && r?.isManagerValidate && !r?.is_assesment_completed && r?.is_feedback_completed && !r?.isManagerFeedback) ? openManagerFeedbackDialog(r) : null }} /></>} */}

            {r?.taskType === 'Manager Review' && (
                <Button
                    className="p-button p-button-sm ess-table-button"
                    severity="warning"
                    icon="pi pi-folder-open"
                    label="Open"
                    style={{ width: '80px' }}
                    onClick={() => {
                        const isInstructorLedValidation =
                            r?.trainingRequisitionForm?.trainingDetails[0]?.trainingType === 'Instructor-Led' &&
                            !r?.trainingRequisitionForm?.trainingDetails[0]?.isManagerValidate &&
                            r?.trainingRequisitionForm?.trainingDetails[0]?.is_assesment_completed &&
                            r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback_completed;

                        const isSelfPacedValidation =
                            r?.trainingRequisitionForm?.trainingDetails[0]?.trainingType === 'Self-Paced' &&
                            !r?.trainingRequisitionForm?.trainingDetails[0]?.isManagerValidate &&
                            !r?.trainingRequisitionForm?.trainingDetails[0]?.is_assesment_completed &&
                            r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback_completed;

                        const isInstructorLedFeedback =
                            r?.trainingRequisitionForm?.trainingDetails[0]?.trainingType === 'Instructor-Led' &&
                            r?.trainingRequisitionForm?.trainingDetails[0]?.isManagerValidate &&
                            r?.trainingRequisitionForm?.trainingDetails[0]?.is_assesment_completed &&
                            r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback_completed &&
                            !r?.trainingRequisitionForm?.trainingDetails[0]?.isManagerFeedback;

                        const isSelfPacedFeedback =
                            r?.trainingRequisitionForm?.trainingDetails[0]?.trainingType === 'Self-Paced' &&
                            r?.trainingRequisitionForm?.trainingDetails[0]?.isManagerValidate &&
                            !r?.trainingRequisitionForm?.trainingDetails[0]?.is_assesment_completed &&
                            r?.trainingRequisitionForm?.trainingDetails[0]?.is_feedback_completed &&
                            !r?.trainingRequisitionForm?.trainingDetails[0]?.isManagerFeedback;

                        if (isInstructorLedValidation || isSelfPacedValidation) {
                            openManagerValidateDialog(r);
                        } else if (isInstructorLedFeedback || isSelfPacedFeedback) {
                            openManagerFeedbackDialog(r);
                        }
                    }}
                />
            )}

            {r?.taskType === 'Training Manager Review' && <><Button className='p-button p-button-sm ess-table-button' severity='warning' icon='pi pi-folder-open' label='Open' style={{ width: '80px' }} onClick={() => { updateTMAssesmentFeedback(r); }} /></>}

        </>)
    }

    const updateTrfAssesment = (rowData) => {
        setClickedRecords(rowData);
        setdetailsViewStatus(false);
        setValidationDialog(false);
        setUpdateAssesmentDialog(true);
    }

    const updateTMAssesmentFeedback = (rowData) => {
        setClickedRecords(rowData);
        setdetailsViewStatus(false);
        setValidationDialog(false);
        setUpdateAssesmentDialog(false);
        setUpdateTMFeedbackDialog(true);
    }

    const openManagerValidateDialog = (rowData) => {
        setClickedRecords(rowData);
        setdetailsViewStatus(false);
        setUpdateAssesmentDialog(false);
        setFeedbackDialog(false);
        setValidationDialog(true);
    }

    const openManagerFeedbackDialog = (rowData) => {
        setClickedRecords(rowData);
        setdetailsViewStatus(false);
        setUpdateAssesmentDialog(false);
        setValidationDialog(false);
        setFeedbackDialog(true);
    }

    const refreshTeamTrainingData = () => {
        setValidationDialog(false);
        setFeedbackDialog(false);
        if (storedUser) {
            var data = JSON.parse(storedUser);
            getTrainingTaskList(data?.id);
        }
    }



    const openApproval = () => {
        setShowApproval(true);
    }


    return (
        <>
            {/* <Dialog header="Update TRF Assesment" visible={updateAssesmentDialog} onHide={() => setUpdateAssesmentDialog(false)} style={{ width: '80vw' }}>
                    <UpdateTRFAssesmentView clickedRowData={clickedRecords} reloadTrfHistory={reloadTrfHistory} />
                </Dialog> */}

            {/* {!validationDialog &&
                <Dialog header="Trainig Validation" visible={validationDialog} style={{ width: '700px' }} onHide={() => setValidationDialog(false)}>
                    <TrainingValidationForm validationData={clickedRecords} closeDialoge={setValidationDialog(false)} reload={refreshTeamTrainingData} />
                </Dialog>
            } */}

            {!showApproval &&
                <div className='ess-page'>
                    <div className='grid'>
                        <div className='col-12' style={{ maxWidth: '600px' }}>
                            <Card title="Employee Overview">
                                <ul className='ess-db-cards'>
                                    {empTrainingOverview.map(x => <li>
                                        <h1 style={{ color: x.severity === 'danger' ? '#f24646' : x.severity === 'success' ? '#4fa226' : x.severity === 'primary' ? '#124d91' : x.severity === 'warning' ? '#e97532' : '#9e9e9e' }}>
                                            {x?.value?.toString().padStart(2, '0')}
                                        </h1>
                                        <small>{x?.label}</small>
                                    </li>)}
                                </ul>
                            </Card>
                        </div>
                        <div className='col'>
                        </div>
                        {/* <div className='col-fixed' style={{ width: '595px' }}>
                        <Card title="RM Overview">
                            <ul className='ess-db-cards'>
                                {managerTrainingOverview.map(x => <li>
                                    <h1 style={{ color: x.severity === 'danger' ? '#f24646' : x.severity === 'success' ? '#4fa226' : x.severity === 'primary' ? '#124d91' : x.severity === 'warning' ? '#e97532' : '#9e9e9e' }}>
                                        {x.value.toString().padStart(2, '0')}
                                    </h1>
                                    <small>{x.label}</small>
                                </li>)}
                            </ul>
                            </Card>
                        </div> */}
                    </div>


                    <div className='ess-table bordered-wrapper'>
                        <h1 className='table-header'>Training Details List</h1>
                        <DataTable value={trainingTaskList} stripedRows responsiveLayout="scroll"
                            paginator
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                        >
                            <Column field="description" header="Descriptions"></Column>
                            <Column header="Actions" style={{ width: '80px', textAlign: 'center' }} body={(rowData) => actionBody(rowData)} />
                        </DataTable>
                    </div>
                </div>
            }
            {showApproval && <AdminTrfListing />}
            {renderValidationDialog()}
            {renderTRFAssesmentDialog()}
            {renderTRFTMFeedbackDialog()}
            {renderManagerValidationDialog()}
            {renderManagerFeedbackDialog()}
            {editTrfDetailsDialog()}
        </>
    )
}

export default TrainingDashboardComponents